import Cookies from 'js-cookie';
import { Outlet } from 'react-router-dom';

const ProtectedRoute = () => {
    const sessionId = Cookies.get('sessionId');
    if (!sessionId) {
        window.location.href = 'https://itqan.ntelgnt.com';
        return;
    }

    return <Outlet />;
}

export default ProtectedRoute;